<template>
  <div class="serveproerinfo">
    <Card class="serveproerinfo-card">
      <div class="topTit">
        <p>基本信息</p>
      </div>
      <div class="tip">
        <!-- 认证信息三种状态2：待审核 3已驳回 -->
        <div class="error">
          <Alert type="error" show-icon v-if="authInfo.certificationStatus == 3">
            已驳回
            <span class="tipRight lineBreak">原因：{{ authInfo.rejectCause || "暂无原因" }}</span>
          </Alert>
        </div>
      </div>
      <div class="content">
        <div class="content-left">
          <div class="userInfo" v-if="userInfo">
            <div class="userImg">
              <img
                v-if="userInfo && userInfo.avatar"
                :src="userInfo.avatar"
                @click="previewPicture(userInfo.avatar)"
              />
              <img v-else src="@/assets/img/avatar.png" />
            </div>
            <div>
              <span>账号名:</span>
              {{ (userInfo && userInfo.account) || "暂未设置账号" }}
            </div>
            <div>
              <span>注册时间:</span>
              {{ userInfo.createTime }}
            </div>
            <div>
              <span>手机号码:</span>
              {{ phone_C?phone_C:'暂未绑定手机号' }}
            </div>
            <div v-show="userInfo.email">
              <span>注册邮箱:</span>
              {{ userInfo.email }}
            </div>
            <div v-show="!userInfo.email">
              <span>注册邮箱:</span> 暂未绑定邮箱
            </div>
          </div>
          <div v-else class="fonttwodark">暂无数据</div>
          <div class="botTit">
            <p>认证信息</p>
          </div>
          <!-- 服务提供者认证信息 -->
          <div class="authYes">
            <div class="authYes-authInfo">
              <div class="logo">
                <span>企业logo：</span>
                <img
                  :src="authInfo.logo"
                  v-if="authInfo.logo != undefined"
                  @click="previewPicture(authInfo.logo)"
                />
                <img v-else src="@/assets/img/user/company_default_logo.png" />
              </div>
              <div class="photo">
                <span>营业执照：</span>
                <img :src="authInfo.license" alt @click="previewPicture(authInfo.license)" />
              </div>
              <div>
                <span>{{ companyName }}</span>
                {{ authInfo.name }}
              </div>
              <div>
                <span>统一社会信用代码：</span>
                {{ authInfo.code }}
              </div>
              <div v-if="authInfo.type == 0">
                <span>经营期限：</span>
                {{ operatingPeriod }}
              </div>
              <div>
                <span>所在地：</span>
                {{ province }}{{ city }}{{ district }}{{ authInfo.address }}
              </div>
              <div>
                <span>法定代表人姓名：</span>
                {{ authInfo.legalPerson }}
              </div>
              <div>
                <span>法定代表人身份证号：</span>
                {{ authInfo.legalPersonIdentity }}
              </div>
              <div v-if="authInfo && authInfo.status == 1">
                <span>被授权人姓名：</span>
                {{ authInfo.authorizerName }}
              </div>
              <div v-if="authInfo && authInfo.status == 1">
                <span>被授权人身份证号：</span>
                {{ authInfo.authorizerIdentity }}
              </div>
              <div class="photo" v-if="authInfo && authInfo.status == 1">
                <span>授权委托书：</span>
                <img
                  :src="authInfo.authorization"
                  alt
                  @click="previewPicture(authInfo.authorization)"
                />
              </div>
              <div class="introduce">
                <span class="introduceTit">企业简介：</span>
                <span class="introduceTxt">{{ authInfo.introduce }}</span>
              </div>
              <div>
                <span>联系人：</span>
                {{ authInfo.contactName }}
              </div>
              <div>
                <span>联系电话：</span>
                {{ authInfo.contactPhone }}
              </div>
              <div>
                <span>邮箱：</span>
                {{ authInfo.contactEmail }}
              </div>
              <p class="returnBtn">
                <!-- 审核通过 -->
                <Poptip
                  class="poptip"
                  confirm
                  transfer
                  placement="top"
                  @on-ok="checkPass"
                  @on-cancel="cancelCheckPass"
                  title="确认通过审核吗？"
                >
                  <Button v-if="authInfo.certificationStatus == 2" class="btn1" type="primary">审核通过</Button>
                </Poptip>

                <!-- 驳回 -->
                <Button
                  v-if="authInfo.certificationStatus == 2"
                  class="btn2"
                  type="error"
                  @click="seeEdit"
                >驳回</Button>
                <Button class="btn" @click="returnList('/servepro/serveproerchecklist')">返回</Button>
              </p>
            </div>
          </div>
        </div>
        <div class="content-right">
          <div class="top"></div>
          <div class="commitlist">
            <div class="commititem mb-16" v-for="(item, index) in historyList" :key="index">
              <div class="flexsb">
                <div>
                  <p v-if="item.status != 3">第{{ item.submitMsg }}次提交</p>
                  <p v-if="item.status == 3">已驳回</p>
                  <p class="mt-4">{{ item.createTime || "暂无" }}</p>
                </div>
                <div>
                  <img src="@/assets/img/video/commit_item.png" alt />
                </div>
              </div>
              <div
                v-if="item.status == 3"
                class="reason mt-16 pt-16 lineBreak"
              >原因：{{ item.rejectCause || "无原因" }}</div>
            </div>
          </div>
        </div>
      </div>
    </Card>
    <applyDown
      v-if="showEdit"
      @close="showEdit = false"
      @confirm="showEdit = false"
      :form="propForm"
    />
    <!-- 预览大图 -->
    <previewImage v-if="preViewModal" v-model="preViewModal" :preView="preView" />
  </div>
</template>

<script>
import {
  getServeProerCheckDetail,
  serveProerCheckPass
} from "@/api/servicePro";

import { CodeToText } from "element-china-area-data";
import applyDown from "../components/ApplyDown";
import previewImage from "@/components/previewImage"; //预览大图组件

export default {
  name: "",
  components: {
    applyDown,
    previewImage
  },
  data() {
    return {
      str: "",
      authFlag: 0, //判断是否认证
      userInfo: {},
      authInfo: {},
      province: "",
      city: "",
      district: "",
      showEdit: false,
      propForm: {},
      serveProerId: "",
      oId: "",
      historyList: [],
      //预览大图
      preViewModal: false, //预览弹窗
      preView: {
        imgSrc: "", //预览图片路径
        title: "" //预览图片标题
      }
    };
  },
  created() {
    this.serveProerId = this.$route.query.id; //获取列表页传递的用户id（查看详情）
    this.oId = this.$route.query.oid; //获取列表页传递的企业id（通过驳回）
    this.getUserInfo();
    // this.gettSocCompanyInfo();
    this.authtoken = "Bearer " + _Cookie.get("adminauth"); //上传图片的token
  },
  methods: {
    previewPicture(src) {
      this.preView.imgSrc = src;
      this.preViewModal = true;
    },
    handleSuccess() {},
    handleError() {},
    checkPass() {
      // 认证审核通过
      serveProerCheckPass(this.authInfo.id)
        .then(res => {
          console.log("res", res);
          this.$Message.success("认证审核通过");
          this.$router.push({ path: "/servepro/serveproerchecklist" });
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    //取消通过
    cancelCheckPass() {
      console.log("点击了取消按钮--审核");
    },
    // 驳回原因
    seeEdit() {
      console.log("this.authInfo.id", this.authInfo.id);
      this.propForm = {
        id: this.authInfo.id
      };
      this.showEdit = true;
    },
    // 获取用户信息
    getUserInfo() {
      getServeProerCheckDetail(this.serveProerId).then(res => {
        console.log("用户信息", res.data.data);
        this.userInfo = res.data.data.userInfo;
        this.authInfo = res.data.data.organInfo;
        this.historyList = res.data.data.historyList;
        this.province = CodeToText[this.authInfo.province];
        this.city = CodeToText[this.authInfo.city];
        this.district = CodeToText[this.authInfo.district];
        this.province = this.authInfo.provinceName;
        this.city = this.authInfo.cityName;
        this.district = this.authInfo.districtName;
        // 默认图片
        // if (!this.userInfo.avatar) {
        //   this.userInfo.avatar = require("@/assets/img/default_avatar.png");
        // }
      });
    },

    returnList(path) {
      this.$router.push({
        path: path
      });
    },
    link(path, userInfo) {
      this.$router.push({
        path: path,
        query: { userId: userInfo.id }
      });
    }
  },
  computed: {
    companyName() {
      if (this.authInfo.type == 0) {
        return "企业名称：";
      } else if (this.authInfo.type == 1) {
        return "政府/单位名称：";
      } else {
        return "组织名称：";
      }
    },
    operatingPeriod() {
      if (this.authInfo.type == "0") {
        if (this.authInfo.isLongTerm == "1") {
          return "长期";
        } else {
          if (
            this.authInfo.isLongTerm == "0" &&
            this.authInfo.businessLimitBegin
          ) {
            return (
              this.authInfo.businessLimitBegin.split(" ")[0] +
              "至" +
              this.authInfo.businessLimitEnd.split(" ")[0]
            );
          } else {
            return "无开始日期";
          }
        }
      }
    },
    /**
     * 手机号加密转换
     */
    phone_C() {
      if (this.userInfo.phone) {
        return this.userInfo.phone.replace(/^(\w{3})\w{4}(.*)$/, "$1****$2");
      }
    },
    /**
     * 密码加密转换
     */
    password_C() {
      const pwdLength = this.userInfo.password.length;
      for (let i = 0; i < pwdLength; i++) {
        this.str = this.str + "*";
      }
      return this.str;
    }
  }
};
</script>

<style lang="scss" scoped>
.serveproerinfo {
  &-card {
    height: calc(100vh - 150px);
    overflow: auto;
    font-size: 14px;
    color: #2f4061;
    box-sizing: border-box;
    min-width: 1024px;
    .topTit {
      font-size: 16px;
      font-family: MicrosoftYaHeiSemibold;
      color: #2f4061;
      font-weight: bold;
      border-bottom: 1px solid #ebedf0;
      box-sizing: border-box;
      padding: 10px 0px;
    }
    .tip {
      margin-top: 10px;
      .ivu-alert {
        color: rgb(140, 230, 176);
      }
      .error {
        .ivu-alert {
          color: rgb(237, 64, 20);
        }
      }
      .tipRight {
        margin-left: 30px;
        width: 100%;
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      &-left {
        flex-grow: 1;
        margin-right: 20px;
        .userInfo {
          margin-top: 30px;
          margin-left: 10px;
          .userImg {
            width: 124px;
            height: 124px;
            border-radius: 62px;
            box-sizing: border-box;
            margin-left: 20px;
            margin-bottom: 20px;
            position: relative;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
            .changeTxt {
              color: #ffffff;
              width: 124px;
              height: 26px;
              background: rgba(0, 0, 0, 0.39);
              position: absolute;
              bottom: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 11px;
            }
          }
          div {
            height: 35px;
            line-height: 35px;
            span {
              color: #67799c;
              display: inline-block;
              width: 80px;
              text-align: right;
              margin-right: 10px;
            }
            i {
              color: #0081ff;
              margin-left: 3px;
            }
            .point {
              cursor: pointer;
            }
          }
        }
        .botTit {
          font-size: 16px;
          font-family: MicrosoftYaHeiSemibold;
          color: #2f4061;
          font-weight: bold;
          border-bottom: 1px solid #ebedf0;
          box-sizing: border-box;
          padding: 10px 0px;
          margin-top: 10px;
        }
        .authNo {
          width: 100%;
          .authImg {
            width: 100%;
            display: flex;
            justify-content: center;
          }
          .authTxt {
            width: 100%;
            display: flex;
            justify-content: center;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #67799c;
          }
          .returnBtn {
            display: flex;
            justify-content: center;
            .btn {
              width: 104px;
              height: 36px;
              background: #ffffff;
              border-radius: 18px;
              border: 1px solid #dcdfe6;
              margin-top: 10px;
            }
          }
        }
        .authYes {
          width: 100%;
          &-authInfo {
            // height: 196px;
            div {
              height: 35px;
              line-height: 35px;
              img {
                width: 138px;
                height: 196px;
              }
              > span {
                color: #67799c;
                display: inline-block;
                width: 175px;
                text-align: right;
                margin-right: 10px;
              }
            }
            .photo {
              height: 100%;
              display: flex;
              align-items: center;
              margin-bottom: 20px;
            }
            .logo {
              height: 120px;
              margin-top: 20px;
              display: flex;
              align-items: center;
              img {
                width: 96px;
                height: 96px;
                border-radius: 48px;
              }
            }
            .introduce {
              height: 100%;
              display: flex;
              .introduceTit {
                display: inline-block;
                width: 175px;
                text-align: right;
                margin-right: 10px;
              }
              .introduceTxt {
                flex: 1;
                text-align: left;
              }
            }
            .returnBtn {
              padding-left: 150px;
              .btn,
              .btn1,
              .btn2 {
                margin-top: 10px;
                margin-bottom: 10px;
                width: 104px;
                height: 36px;
                border-radius: 18px;
                border: 1px solid #dcdfe6;
                margin-right: 15px;
              }
            }
          }
        }
      }
      &-right {
        max-width: 364px;
        min-width: 364px;
        overflow: auto;
        max-height: calc(100vh - 280px);
        overflow: auto;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        // border: solid;
        > .top {
          height: 118px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #dcdfe6;
          padding: 24px;
          background-image: url("~@/assets/img/video/commit_img.png");
          background-repeat: no-repeat;
          background-size: 100%;
          .line {
            width: 32px;
            height: 2px;
            background: #3c8aff;
          }
        }
        > .commitlist {
          padding: 16px 24px;
          // height: calc(100% - 118px);
          // overflow: auto;
          .commititem {
            width: 100%;
            padding: 12px 24px;
            background: rgba(220, 223, 230, 0.1);
            border: 1px dashed #dcdfe6;
            border-radius: 4px;
            .reason {
              border-top: 1px solid rgba(246, 247, 249, 1);
            }
          }
        }
        > .commitlist div:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }
}
</style>